import { all, call, put, select, takeLatest } from "redux-saga/effects";
import { normalize, schema } from "normalizr";

import { showError } from "../../utils/sagasErrorHandler";

import { getPublishRequestStatusesRequest } from "./api";
import { getPublishRequestStatuses, setPublishRequestStatuses } from "./actions";
import { publishRequestStatusesSelector } from "./selectors";

const publishRequestStatusesSchema = new schema.Entity("publish_request_statuses" , {},{ idAttribute: "code" });
const publishRequestStatusesListSchema = new schema.Array(publishRequestStatusesSchema);

function* getPublishRequestStatusesWorker() {
    try {
        const { codes } = yield select(publishRequestStatusesSelector);

        if(!codes.length){
            yield put(setPublishRequestStatuses({ isLoadingPublishRequestStatuses: true }));
            const { publish_request_statuses } = yield call(getPublishRequestStatusesRequest);
            const { result, entities } = normalize(publish_request_statuses, publishRequestStatusesListSchema);
            yield put(setPublishRequestStatuses({
                isLoadingPublishRequestStatuses: false,
                codes: result,
                publishRequestStatuses: entities.publish_request_statuses
            }));
        }
    } catch (error) {
        yield put(setPublishRequestStatuses({ isLoadingPublishRequestStatuses: false }));
        showError(error);
    }
}

export function* publishRequestStatusesSagas() {
    yield all([
        yield takeLatest(getPublishRequestStatuses, getPublishRequestStatusesWorker)
    ]);
}
